import { RESULTS_PER_PAGE } from 'search/enums/constants';
import { filterKeysToExclude } from 'search/utils/filterKeysToExclude';

export const getCurrentSort = (sortBy, sortOrder, recentlyReleasedValue = null) => {
  if (recentlyReleasedValue === 'apparel') {
    return 'new_in_apparel';
  }

  if (recentlyReleasedValue === 'sneakers') {
    return 'recently_released_sneakers';
  }

  if (sortBy === 'date_added' && sortOrder === 'descending') {
    return 'new_in';
  }

  if (sortBy === 'relevance' && sortOrder === 'descending') {
    return 'popular';
  }

  if (sortBy === 'release_date' && sortOrder === 'ascending') {
    return 'upcoming_releases';
  }

  if (sortBy?.includes('lowest_price_cents') && sortOrder === 'ascending') {
    return 'price_low_to_high';
  }

  if (sortBy?.includes('lowest_price_cents') && sortOrder === 'descending') {
    return 'price_high_to_low';
  }

  return 'popular';
};

export const getImageType = (imageUrl, sellerImage) => {
  const isPlaceholderImage = imageUrl?.includes('/placeholders/');
  if (isPlaceholderImage) {
    return 'placeholder';
  }

  return sellerImage ? 'used' : 'new';
};

export const getAppliedFilters = (query) => {
  const filtersApplied = { ...query };
  const result = {};
  for (const key of filterKeysToExclude) delete filtersApplied[key];

  for (const [key, value] of Object.entries(filtersApplied)) {
    result[key] = Array.isArray(value) ? value : [value];
  }

  return Object.keys(result).length > 0 ? JSON.stringify(result) : '';
};

/**
 * [getResultIdForEventTracking] based on the position in the grid, it is associated to a resultId
 * resultIds comes from the result_id from each request
 * @param position
 * @param resultIds
 */
export const getResultIdForEventTracking = (position, resultIds) => {
  const index = Math.floor((position - 1) / RESULTS_PER_PAGE) - 1;

  if (index < 0) {
    return resultIds?.[0];
  }

  return resultIds?.[index];
};
